import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { hrmWorkflowSteps } from "../hrmModulesData";
import HrmImagePlaceholder from "./HrmImagePlaceholder";

const stepIcons = [
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4 20c0-4 3.5-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 2v4M16 2v4M4 10h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="6" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M3 10h18" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3l2.4 4.8 5.3.8-3.8 3.7.9 5.3L12 15.8 7.2 17.6l.9-5.3L4.3 8.6l5.3-.8L12 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="4" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="3" y="14" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
];

const HrmHowItWorksSection: React.FC = () => {
  return (
    <section className="wdev-process hrm-how" aria-labelledby="hrm-how-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="hrm-how-title"
            className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
          >
            HRM — How It Works?
          </h2>
          <p className="hrm-how__lead">
            Interested in learning how your HRM system operates behind the scenes? Here&apos;s a
            brief glimpse at the human resource management workflow.
          </p>
        </AnimatedSection>

        <AnimatedSection className="hrm-how__visual-wrap" delay={0.1}>
          <HrmImagePlaceholder
            variant="devices"
            label="HRM Workflow"
            hint="Admin dashboard · Employee portal · Payroll & attendance"
            className="hrm-how__placeholder"
          />
        </AnimatedSection>

        <div className="wdev-process__timeline">
          <div className="wdev-process__line" aria-hidden="true" />
          {hrmWorkflowSteps.map((step, index) => (
            <motion.div
              key={step.title}
              className="wdev-process__step"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              <div className="wdev-process__badge">{String(index + 1).padStart(2, "0")}</div>
              <div className="wdev-process__card">
                <div className="wdev-process__icon">{stepIcons[index]}</div>
                <h3 className="wdev-process__title">{step.title}</h3>
                <p className="wdev-process__desc">{step.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HrmHowItWorksSection;
